module.exports = __webpack_public_path__ + "img/lms.25ed8c15.png";